
import { useResult } from "@vue/apollo-composable";
import gql from "graphql-tag";
import { defineComponent, watch } from "vue";
import { useRouter } from "vue-router";
import BreadCrumb from "./components/BreadCrumb.vue";
import NavigationBar from "./components/NavigationBar.vue";
import Splash from "./components/Splash.vue";
import UserCatalogSettingsNotice from "./components/UserCatalogSettingsNotice.vue";
import useGlobalLoading from "./composables/useGlobalLoading";
import useOidc from "./composables/useOidc";
import useUser from "./composables/useUser";
import useUserCatalogSettings from "./composables/useUserCatalogSettings";
import { useGetProfileQuery } from "./graphql/types";
import { isValidGuid } from "./composables/utils";

gql`
  query GetProfile {
    userProfile {
      isAdmin
      isSuperAdmin
      isUserAdmin
      isApplicationAdmin
      name
      userId
      organizationId
      roles
    }
  }
`;

export default defineComponent({
  components: { NavigationBar, BreadCrumb, Splash, UserCatalogSettingsNotice },
  setup() {
    const oidc = useOidc();
    const router = useRouter();
    const user = useUser();
    const { result, error, onError, refetch } = useGetProfileQuery(() => ({
      fetchPolicy: "network-only",
      enabled: oidc.user.value != null, // This creates a reactive dependency on oidc.user.value. Any change to this value will re-trigger the query. In case useGetProfileQuery fails, it might cause a loop if oidc.user.value is modified in the error handling logic.
    }));

    watch(
      useUserCatalogSettings().sessionId,
      (sessionId, previousSessionId) => {
        if (sessionId && previousSessionId) refetch();
      }
    );

    // Handle errors without causing reactive updates
    onError((error) => {
      console.error("Profile query failed:", error);
      // Don't trigger any reactive updates that affect oidc.user.value
      return;
    });

    watch(
      () => useResult(result).value,
      (newValue) => {
        user.setUser(newValue ?? undefined);
      },
      { immediate: true }
    );

    return {
      isLoading: useGlobalLoading().isLoading,
      user: user.user,
    };
  },
});
